import type { Deal } from '@paintscout/api'
import type { Task } from 'paintscout'
import type { TaskTemplateOption } from '../../options'
import { createTask } from '../create-task/create-task'
import { uuid } from '../../util'

export function createTasksFromTemplate(args: {
  template: TaskTemplateOption
  deal: Deal
  overrides?: Partial<Task>
}): Task[] {
  const { template, deal, overrides } = args
  const tasks: Task[] = []
  const order = template.order
  const templateInstanceId = uuid()

  for (const taskKey of order) {
    const taskData = template.values[taskKey]

    const { title, notes } = taskData || {}

    if (taskData) {
      const task = createTask({
        task: {
          title,
          notes,
          dealId: deal._id
        },
        owner: deal.owner!
      })
      tasks.push({
        ...task,
        template: {
          id: templateInstanceId,
          index: order.indexOf(taskKey),
          templateKey: template.key,
          templateLabel: template.label,
          taskKey: taskKey,
          taskLabel: taskData.title,
          appliedAt: Date.now()
        },
        ...overrides
      })
    }
  }

  return tasks
}
